let memoizedColumns = []
const BulkUplaodColumn = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'name',
            header: 'ID',
        },
        {
            accessorKey: 'status',
            header: 'Status',
        },
        
       
    ]
    return memoizedColumns
}
export default BulkUplaodColumn